import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { apiGetProductInfo } from "Root/api/apiCheckout";
import { Header, ProductSection, Product, Loading, QuizRetake, RDBlock } from "CheckoutComponents";
import waterbottle from "Images/checkout/waterbottle.png";
import blenderbottle from "Images/checkout/blenderbottle.png";
import matt from "Images/checkout/dietitian_matt_mob.png";
import mattdesk from "Images/checkout/dietitian_matt_desk.png";
import styles from "./styles.module.css";
const rdLineItem = {
    image_url: matt,
    image_url_desk: mattdesk,
    title: "Matt Mazzino, R.D.",
    product_description: "",
    gross_price: "$200.00",
    net_price: "FREE",
    item_type: "",
    delivery_cadence: "",
    flavor_prefix: null,
    item_key: "rd",
    quantity: null,
    unit_container_type: null,
    servings: null,
    flavor_attribute_description: "Enjoy unlimited, one-on-one access to your Registered Dietitian. Reach out any time for expert advice on your fitness goals, nutrition, or Gainful products.",
};
function Cart(props) {
    const [productsDetails, setProductsDetails] = useState({});
    // const [icons, setIcons] = useState([]);
    const [name, setName] = useState("");
    useEffect(() => {
        const getPersonalizationsData = async (key) => {
            const data = (await apiGetProductInfo(key));
            if (data) {
                setProductsDetails(data);
                setName(data.protein.name);
            }
        };
        getPersonalizationsData("all");
    }, []); // Only run once
    const isBoost = (item) => item.item_type === "collagen" ||
        item.item_type === "boost" ||
        item.item_type === "fiber" ||
        item.item_type === "creatine";
    const getAccessoriesData = (item) => props.accessoriesData.filter((el) => el.item_key === item.item_type)[0];
    const fullwidth_products = [
        _jsx(_Fragment, { children: props.userCart.map((item, i) => (_jsx(Product, { image: item.item_key === "blender" ? blenderbottle : item.image_url, row: true, reversed: true, deliveryCadence: item.delivery_cadence, servings: item.servings && `${String(item.servings)} servings`, regularPrice: item.gross_price, netPrice: item.net_price, title: productsDetails[item.item_type]?.product_title || item.title, 
                // @ts-ignore
                description: productsDetails[item.item_type]?.reason_why || getAccessoriesData(item)?.product_explanation, included: props.cart[item.item_type] > 0, shortName: item.item_type, removeFromCart: props.removeFromCart, addToCart: props.addToCart, showMoreDetails: true, fname: name, icons: productsDetails[item.item_type]?.icons, category: "personalized", updatingItems: props.updatingItems, isBoost: isBoost(item), editable: false, showPrice: props.showPrice, flavors: [] }, item.item_type + i.toString()))) }),
    ];
    const carousel_products = props.cartItems.map((item) => {
        const bottleImage = item.item_key === "waterbottle" ? waterbottle : blenderbottle;
        return (_jsx(Product, { image: item.image_url ? item.image_url : bottleImage, row: false, reversed: false, deliveryCadence: item.delivery_cadence, servings: item.servings.toString(), regularPrice: item.gross_price, netPrice: item.net_price, title: item.title, description: item.product_explanation, flavors: [], included: props.cart[item.item_key] > 0, shortName: item.item_category === "personalized" ? item.item_type : item.item_key, removeFromCart: props.removeFromCart, addToCart: props.addToCart, showMoreDetails: true, fname: name, category: item.item_type, updatingItems: props.updatingItems, isBoost: isBoost(item), isCarousel: true, showPrice: props.showPrice }, item.item_key));
    });
    return (_jsxs(_Fragment, { children: [_jsx(Header, { theme: "dark", fname: props.userName, name: name }), _jsx("div", { className: styles.areawrap, children: _jsx("div", { className: styles.productarea, children: props.userCart.length > 0 ? (_jsxs(_Fragment, { children: [_jsx(ProductSection, { isCarousel: false, title: "Your system: ", products: fullwidth_products, personalized: true }), _jsx(RDBlock, { ...rdLineItem }), props.userCart.length > 0 && _jsx(QuizRetake, {}), carousel_products?.length > 0 && (_jsx(ProductSection, { title: "Customers also bought", products: carousel_products, isCarousel: true, personalized: false }))] })) : (_jsx(Loading, {})) }) })] }));
}
export default Cart;
